// extracted by mini-css-extract-plugin
export default {"container":"search_commentary_snippet-module__container--36qdS"};